import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as IconMore } from "../Images/icon_more.svg";
import "../Styles/component.css";
import "../Styles/global.css";

const MoreBtnMembers = ({
  isClicked,
  onToggle,
  onClose,
  option1,
  option2,
  option3 = "",
  option1Click,
  option2Click = null,
  option3Click = null,
}) => {
  const clickRef = useRef(null);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});
  const menuItems = [
    { label: option1, onClick: option1Click },
    { label: option2, onClick: option2Click },
    { label: option3, onClick: option3Click },
  ].filter((item) => item.label && item.onClick);

  const updateMenuPosition = () => {
    if (!buttonRef.current) {
      return;
    }

    const rect = buttonRef.current.getBoundingClientRect();
    const menuWidth = 129;
    const menuHeight = 8 + menuItems.length * 48;
    const enoughBottomSpace = window.innerHeight - rect.bottom >= menuHeight + 12;

    setMenuStyle({
      position: "fixed",
      width: "129px",
      left: Math.max(rect.right - menuWidth, 12),
      top: enoughBottomSpace
        ? rect.bottom + 6
        : Math.max(rect.top - menuHeight - 6, 12),
      zIndex: 1000,
      paddingBottom: "4px",
    });
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onToggle();
  };
  const handleClickOutside = (e) => {
    const isInsideButton = clickRef.current?.contains(e.target);
    const isInsideMenu = menuRef.current?.contains(e.target);

    if (!isInsideButton && !isInsideMenu) {
      onClose();
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    if (!isClicked) {
      return;
    }

    updateMenuPosition();
    window.addEventListener("resize", updateMenuPosition);
    window.addEventListener("scroll", updateMenuPosition, true);

    return () => {
      window.removeEventListener("resize", updateMenuPosition);
      window.removeEventListener("scroll", updateMenuPosition, true);
    };
  }, [isClicked, menuItems.length]);

  const buttonStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    zIndex: 4,
    ...(isClicked ? { backgroundColor: "#f5f5f5" } : {}),
  };

  return (
    <div
      ref={clickRef}
      style={{ position: "relative", zIndex: isClicked ? 30 : 4 }}
    >
      <div
        ref={buttonRef}
        className="center"
        style={buttonStyle}
        onClick={handleClick}
      >
        <IconMore />
      </div>
      {isClicked
        ? createPortal(
            <div
              ref={menuRef}
              className="editOrdelete_Box"
              style={menuStyle}
              onClick={(e) => e.stopPropagation()}
            >
              {menuItems.map((item) => (
                <div
                  key={item.label}
                  className="editOrdelete_Btn edit"
                  style={{ width: "101px", height: "24px", padding: "8px 14px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                    item.onClick();
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
            ,
            document.body
          )
        : ""}
    </div>
  );
};

export default MoreBtnMembers;
